/**
 * DreamPay Private API
 * Private API v2 - Current version with JWT authentication, role-based access control, and enhanced security features.
 *
 * The version of the OpenAPI document: v2
 * Contact: suporte@dreampay.com.br
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface RegisterDeviceResponseV2 {
  deviceId?: string;
}
